import { isLocalhost } from '@booksy-com/vue-tools'

import { resolveCountryGatewayOrigin } from './resolve-country-gateway-origin'

export const BOOKSY_ASSISTANT_API_V1 = '/booksy-assistant/v1'

export const BOOKSY_ASSISTANT_APP_NAME = 'booksy_assistant_agent'

function normalizeApiPath (apiPath: string): string {
  return apiPath.startsWith('/') ? apiPath : `/${apiPath}`
}

function usesDevProxy (): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  return process.env.VUE_APP_PROXY_LOCALHOST === 'true'
    || isLocalhost(window.location.origin)
}

export function resolveBooksyAssistantApiUrl (
  apiPath: string,
  country: string,
  apiUrl?: string
): string {
  const path = normalizeApiPath(apiPath)

  if (usesDevProxy()) {
    return path
  }

  return `${resolveCountryGatewayOrigin(country, apiUrl)}${path}`
}

export function agentCreateSessionUrl (
  userId: string | number,
  country: string,
  apiUrl?: string
): string {
  return resolveBooksyAssistantApiUrl(
    `${BOOKSY_ASSISTANT_API_V1}/apps/${BOOKSY_ASSISTANT_APP_NAME}/users/${userId}/sessions`,
    country,
    apiUrl
  )
}

export function agentRunSseUrl (country: string, apiUrl?: string): string {
  return resolveBooksyAssistantApiUrl(
    `${BOOKSY_ASSISTANT_API_V1}/run_sse`,
    country,
    apiUrl
  )
}

export function agentDeleteSessionUrl (
  userId: string | number,
  sessionId: string,
  country: string,
  apiUrl?: string
): string {
  return resolveBooksyAssistantApiUrl(
    `${BOOKSY_ASSISTANT_API_V1}/apps/${BOOKSY_ASSISTANT_APP_NAME}/users/${userId}/sessions/${sessionId}`,
    country,
    apiUrl
  )
}
